import { loadStripe } from '@stripe/stripe-js'
import { useMyLanguage } from 'app/_hooks'
import { useMemo } from 'react'
import browserEnv from './env/browserEnv'

export const useStripePromise = () => {
  const myLanguage = useMyLanguage()
  const locale = myLanguage ?? 'en'

  const stripePromise = useMemo(
    () => loadStripe(browserEnv.NEXT_PUBLIC_STRIPE_PK, { locale }),
    [locale],
  )

  return stripePromise
}
